import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import empRegister from "../Assets/Employer/empRegister.png";
import { useNavigate } from "react-router-dom";

export default function RegisterAndLogin() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    companyName: "",
    email: "",
    password: "",
    mobileNumber: "",
  });
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = "Full Name is required.";
    if (!formData.companyName) newErrors.companyName = "Company Name is required.";
    if (!formData.email) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Enter a valid email.";
    if (!formData.password) newErrors.password = "Password is required.";
    else if (formData.password.includes(" ")) newErrors.password = "Spaces are not allowed in the password.";
    else if (formData.password.length < 6) newErrors.password = "Password must be at least 6 characters.";
    if (!formData.mobileNumber) newErrors.mobileNumber = "Mobile Number is required.";
    else if (!/^\+?\d{10,15}$/.test(formData.mobileNumber)) newErrors.mobileNumber = "Enter a valid mobile number.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const formDataToSend = new FormData();
      formDataToSend.append("email", formData.email);
      formDataToSend.append("password", formData.password);
      formDataToSend.append("emp_profile.full_name", formData.fullName);
      formDataToSend.append("emp_profile.mobile_number", formData.mobileNumber);
      formDataToSend.append("emp_profile.company_name", formData.companyName);

      try {
        const response = await axios.post(
          "http://127.0.0.1:8000/empregistration/register/",
          formDataToSend,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        alert(response.data.message);
        setIsOtpSent(true);
      } catch (error) {
        console.error("Error Response:", error);
        handleApiErrors(error);
      }
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "http://127.0.0.1:8000/empregistration/verify-otp/",
        { email: formData.email, otp }
      );
      alert(response.data.message);
      navigate("/Employerdb");
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const handleApiErrors = (error) => {
    if (error.response) {
      console.error("Error Data:", error.response.data);
      alert(error.response.data.message || "An error occurred.");
    } else if (error.request) {
      console.error("No Response Received:", error.request);
      alert("No response received from the server.");
    } else {
      console.error("Error Message:", error.message);
      alert("An unexpected error occurred.");
    }
  };

  return (
    <div className="bg-gray-100 w-full flex justify-center items-center min-h-screen">
      <div className="bg-white w-full max-w-7xl rounded-3xl flex overflow-hidden my-10 shadow-lg">
        {/* Left Side */}
        <div className="hidden md:flex flex-col justify-center items-center w-1/3 p-6">
          <div className="mb-6 p-4 border border-[#0077af] bg-white rounded-md text-center">
            <h2 className="text-2xl text-gray-800 mb-2">Recruit with JobGenne</h2>
            <button className="bg-[#0077af] text-white px-6 py-3 rounded-md hover:bg-blue-600 w-full md:w-auto">
              Buy Plan
            </button>
          </div>
          <img
            src={empRegister}
            alt="Registration Illustration"
            className="w-[550px] h-[450px] object-contain mt-0"
          />
          <div className="mt-4 p-4 border border-[#0077af] bg-white rounded-md max-w-xs mx-auto text-center">
            <p className="text-gray-700 font-medium mb-2">Already have an Employer Account?</p>
            <button
              onClick={() => navigate("/EmployerLogin")}
              className="px-6 py-3 bg-[#0077af] text-white text-lg font-semibold rounded-md hover:bg-blue-600 mx-auto"
            >
              Login
            </button>
          </div>
        </div>

        {/* Right Side */}
        <div className="p-10 text-black flex flex-col justify-center items-start gap-8 w-full md:w-1/2">
          <div className="flex justify-between items-center w-full">
            <span></span>
            <button
              onClick={() => navigate("/")}
              className="flex items-center text-gray-300 hover:text-red-600 transition-colors duration-300"
            >
              <FaTimes className="mr-2" />
            </button>
          </div>

          {!isOtpSent ? (
            <>
              <h1 className="text-2xl font-medium">Create your Jobgenee Profile</h1>
              <form className="flex flex-col justify-start items-start gap-6 w-full" onSubmit={handleSubmit}>
                <div className="w-full">
                  <label>Full Name<span className="text-red-500"> *</span></label>
                  <input
                    type="text"
                    name="fullName"
                    placeholder="What is your name?"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full"
                  />
                  {errors.fullName && <p className="text-red-500 text-sm">{errors.fullName}</p>}
                </div>

                <div className="w-full">
                  <label>Company Name<span className="text-red-500"> *</span></label>
                  <input
                    type="text"
                    name="companyName"
                    placeholder="Your company name"
                    value={formData.companyName}
                    onChange={handleChange}
                    className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full"
                  />
                  {errors.companyName && <p className="text-red-500 text-sm">{errors.companyName}</p>}
                </div>

                <div className="w-full">
                  <label>Email Id<span className="text-red-500"> *</span></label>
                  <input
                    type="text"
                    name="email"
                    placeholder="Write your Email Id"
                    value={formData.email}
                    onChange={handleChange}
                    className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full"
                  />
                  {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                </div>

                <div className="w-full">
                  <label>Password<span className="text-red-500"> *</span></label>
                  <div className="relative w-full">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Create a password"
                      value={formData.password}
                      onChange={handleChange}
                      className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full pr-10"
                    />
                    <span
                      className="absolute top-3 right-3 cursor-pointer text-xl text-gray-500"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                    </span>
                  </div>
                  {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
                </div>

                <div className="w-full">
                  <label>Mobile Number<span className="text-red-500"> *</span></label>
                  <input
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full"
                  />
                  {errors.mobileNumber && <p className="text-red-500 text-sm">{errors.mobileNumber}</p>}
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#0077af] text-white py-3 rounded-xl hover:bg-blue-600"
                >
                  Register
                </button>
              </form>
            </>
          ) : (
            <>
              <h1 className="text-2xl font-medium">Verify OTP</h1>
              <form className="flex flex-col gap-4 w-full" onSubmit={handleOtpSubmit}>
                <input
                  type="text"
                  name="otp"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="border border-gray-400 rounded-xl px-2 py-2 w-full"
                />
                <button
                  type="submit"
                  className="w-full bg-[#0077af] text-white py-3 rounded-xl hover:bg-blue-600"
                >
                  Verify
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
